import BoatIcon from '../../../public/assets/icons/boat.svg';
import ModelIcon from '../../../public/assets/icons/frame.svg';
import MarinaIcon from '../../../public/assets/icons/anchor.svg';

export default function PartnerStats({ partner }) {
  const stats = [
    {
      name: 'Boote',
      stat: partner.counts.boats,
      icon: BoatIcon,
    },
    {
      name: 'Modelle',
      stat: partner.counts.models,
      icon: ModelIcon,
    },
    {
      name: 'Destinationen',
      stat: partner.counts.basements,
      icon: MarinaIcon,

    },
  ];

  return (
    <div>
      <dl
        className=" grid grid-cols-1 overflow-hidden  divide-y divide-gray-200 md:grid-cols-3 md:divide-y-0 md:divide-x order-1 sm:order-2"
      >
        {stats.map((item) => (
          <div key={item.name} className="px-7 py-3 flex items-center space-between bg-action">
            <dt className="font-bold uppercase text-primary">
              <div className="text-5xl mb-1">{item.stat}</div>
              <span className="text-primary opacity-60 line-clamp-1 overflow-hidden">{item.name}</span>
            </dt>
            <dd className="mt-1 ml-auto">
              <item.icon className="h-20 fill-action-200" />
            </dd>
          </div>
        ))}
      </dl>
    </div>
  );
}
